import { NotificationType } from 'vscode-languageserver-protocol';
import { DocumentUri, TextDocument } from 'vscode-languageserver-textdocument';
import { FeatureState } from './feature_state/feature_state_management_types';

export { DidChangeThemeNotificationType } from '@gitlab-org/webview-theme';

export const TOKEN_CHECK_NOTIFICATION = '$/gitlab/token/check';
export const FEATURE_STATE_CHANGE = '$/gitlab/featureStateChange';

export type FeatureStateNotificationParams = FeatureState[];

export const FeatureStateChangeNotificationType =
  new NotificationType<FeatureStateNotificationParams>(FEATURE_STATE_CHANGE);

export interface TokenCheckNotificationParams {
  message?: string;
}

export const TokenCheckNotificationType = new NotificationType<TokenCheckNotificationParams>(
  TOKEN_CHECK_NOTIFICATION,
);
// TODO: once the following clients are updated:
//
// - JetBrains: https://gitlab.com/gitlab-org/editor-extensions/gitlab-jetbrains-plugin/-/blob/main/src/main/kotlin/com/gitlab/plugin/lsp/GitLabLanguageServer.kt#L16
//
// We should remove the `TextDocument` type from the parameter since it's deprecated
export type DidChangeDocumentInActiveEditorParams = TextDocument | DocumentUri;
export const DidChangeDocumentInActiveEditor =
  new NotificationType<DidChangeDocumentInActiveEditorParams>(
    '$/gitlab/didChangeDocumentInActiveEditor',
  );

export interface StreamWithId {
  /** unique stream ID */
  id: string;
}
export interface StreamingCompletionResponse {
  /** stream ID taken from the request, all stream responses for one request will have the request's stream ID */
  id: string;
  /** most up-to-date generated suggestion, each time LS receives a chunk from LLM, it adds it to this string -> the client doesn't have to join the stream */
  completion?: string;
  done: boolean;
}

export const STREAMING_COMPLETION_RESPONSE_NOTIFICATION = 'streamingCompletionResponse';
export const CANCEL_STREAMING_COMPLETION_NOTIFICATION = 'cancelStreaming';
export const StreamingCompletionResponseNotificationType =
  new NotificationType<StreamingCompletionResponse>(STREAMING_COMPLETION_RESPONSE_NOTIFICATION);
export const CancelStreamingNotificationType = new NotificationType<StreamWithId>(
  CANCEL_STREAMING_COMPLETION_NOTIFICATION,
);

export const API_ERROR_NOTIFICATION = '$/gitlab/api/error';
export const API_RECOVERY_NOTIFICATION = '$/gitlab/api/recovered';

export const ApiErrorNotificationType = new NotificationType<void>(API_ERROR_NOTIFICATION);
export const ApiRecoveryNotificationType = new NotificationType<void>(API_RECOVERY_NOTIFICATION);
